function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 6,
  width: 2,
  height: 64,
  fill: "#00C92C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.5 0H10.5L7.32925 3H6.6712L3.5 0Z",
  fill: "#00C92C"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5 64H3.5L6.67075 61H7.3288L10.5 64Z",
  fill: "#00C92C"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 1,
  fill: "#00C92C"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  y: 63,
  width: 14,
  height: 1,
  fill: "#00C92C"
});

var SvgIcTransitionPlaceholder = function SvgIcTransitionPlaceholder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 64,
    viewBox: "0 0 14 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcTransitionPlaceholder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_transition_placeholder.14ecc3be.svg";
export { ForwardRef as ReactComponent };